import { createReducer, getType } from 'typesafe-actions';
import qs from 'query-string';

import { getProductList } from '../utils';

import { purchase, productPriceInfoListUpdated } from './actions';

import { Product, PromotionProduct, ProductState, initialProductState } from './types';

if (typeof window !== 'undefined') {
  window.productPriceInfoListUpdated = () => {
    window.store?.dispatch(productPriceInfoListUpdated());
  };
}

const itemsToPromotionItems = (items: Product[]) => {
  const queryParams = qs.parse(window.location.search, {
    arrayFormat: 'comma',
  });
  let ids: string[] = [];
  if (queryParams?.productIds) {
    ids = typeof queryParams.productIds === 'string' ? [queryParams.productIds] : queryParams.productIds as string[];
  }

  const promotionItems: PromotionProduct[] = ids
    .map((id: string) => items.find((x: Product) => x.productId === id) as Product)
    .reduce((arr: PromotionProduct[], curr, index: number, src) => {
      if (index % 2 === 0) {
        arr.push({
          discountProduct: curr,
          product: src[index + 1],
        });
      }
      return arr;
    }, []);

  return promotionItems.sort((a, b) => {
    const aPrice = a.product.displayPriceString.replace(/\D/g, '');
    const bPrice = b.product.displayPriceString.replace(/\D/g, '');
    return parseFloat(bPrice) - parseFloat(aPrice);
  });
};

const productReducer = (initialState = initialProductState) => {
  const computedInitialState = {
    ...initialState,
    items: getProductList(),
  };
  if (computedInitialState.items.length) {
    computedInitialState.promotionItems = itemsToPromotionItems(computedInitialState.items);
  }

  if (typeof window !== 'undefined') {
    window.purchaseFinished = (productId, success) => {
      if (success) {
        window.store.dispatch(purchase());
      }
    };
  }

  return createReducer<ProductState>(computedInitialState, {
    [getType(purchase)]: (state) => {
      window.AzarJs?.closePopup();
      return state;
    },
    [getType(productPriceInfoListUpdated)]: (state) => {
      const items = getProductList();
      return {
        ...state,
        items,
        promotionItems: itemsToPromotionItems(items),
      };
    },
  });
};

export default productReducer;
